import { Button, Typography } from '@material-ui/core'
import React, { ChangeEvent, Dispatch, ReactNode } from 'react'
import { UserWithOrganizationResponseDTO, SubGroupsClient, ModemWithOrgSiteResponseDTO, ModemsClient, OrganizationsClient } from '../generated/ApiClient'
import { Formik, Form } from 'formik'
import { useDispatch, useSelector } from "react-redux";
import { actionCreators as snackbar } from '../store/AlertSnackbarStore'
import ValuePickerControl from '../common/ValuePickerControl'
import { RouteComponentProps } from 'react-router'
import { ApplicationState } from '../store'

async function formSubmitCallback(subgroupId: string | undefined, modemId: string, dispatch: Dispatch<any>) {
    try {
        if (subgroupId) {
            await new SubGroupsClient().addModem3(subgroupId, modemId);
            dispatch(snackbar.addMessage({ title: "Success", message: `Modem successfully added`, alertType: 'success' }))
        }
    }
    catch (error) {
        dispatch(snackbar.addError(error, undefined, 'Error writing to the database'));
    }
}

export default function AddModemToSubgroup(props: RouteComponentProps<{ organizationId: string, subgroupId: string }>) {
    const dispatch = useDispatch();
    const [selectedModemId, setSelectedModemId] = React.useState('0');
    const [modems, setModems] = React.useState<ModemWithOrgSiteResponseDTO[]>([]);

    React.useEffect(() => {
        const fetchData = async () => {
            const allModems = await new OrganizationsClient().getAllModemsAll(props.match.params.organizationId);
            if (allModems.length > 0) {
                setModems(allModems);
                setSelectedModemId(allModems[0]?.modemHostId)
            }
        }
        fetchData();
    }, [props.match.params.organizationId, props.match.params.subgroupId]);

    const modemList = modems.map(x => {
        return { text: x.label ?? x.modemHostId, value: x.modemHostId }
    })

    const handleModemChange = (event: ChangeEvent<{ name?: string | undefined; value: unknown; }>, child: ReactNode) => {
        let target = event.target as HTMLInputElement;
        setSelectedModemId(target.value)
    };
    return (
        <>
            <Formik initialValues={{}}
                onSubmit={async (values, _) => formSubmitCallback(props.match.params.subgroupId, selectedModemId, dispatch)}>
                {/* supply a function to formik so that we can access these props*/}
                {({ submitForm, isSubmitting, touched }) => (
                    <>
                        <Form translate='yes'>
                            <Typography paragraph display='inline'><b>Modems</b></Typography>
                            <ValuePickerControl items={modemList} handleChange={handleModemChange}></ValuePickerControl>
                        </Form>
                        <Button style={{ marginTop: 20 }} variant='contained' color='primary' size='medium' onClick={submitForm}>Add</Button>
                    </>
                )}
            </Formik>
        </>
    )
}